import { clientCaseFactFindLetterOfAuthorityPrintApi } from './print';

export function clientCaseFactFindLetterOfAuthorityApi(path: string) {
  return {
    path,
    print: () => clientCaseFactFindLetterOfAuthorityPrintApi(`${path}/print`),
  };
}
